module.exports = __webpack_public_path__ + "static/media/plus.76776981.png";